// PUBLIC_URL is empty for a custom domain and /repository for a Pages project site.
export const siteBase = (process.env.PUBLIC_URL || "").replace(/^https?:\/\/[^/]+/, "").replace(/\/+$/, "");
export const backendEnabled = process.env.REACT_APP_ENABLE_BACKEND === "true";
export function siteUrl(path: string): string {
  return `${siteBase}${path}`;
}
export function sitePath(path: string): string {
  return siteBase && (path === siteBase || path.startsWith(`${siteBase}/`))
    ? path.slice(siteBase.length) || "/" : path;
}
